// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// ANTD
import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/css';
import TextInput from 'components/inputs/TextInput';
import TextAreaInput from 'components/inputs/TextAreaInput';
import Form from 'antd/lib/form';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
// APOLLO
import submitGetQuoteForm from 'ApolloClient/Mutations/submitGetQuoteForm';
import { graphql } from 'react-apollo';
import ErrorHelpers from '../../../lib/helpers/ErrorHelpers/index';

const ButtonContainer = styled.div`
  margin-top: 20px;
`;

class ContactUsForm extends React.PureComponent {
  state = {
    loading: false,
  };

  onCreate = async variables => {
    const { onComplete } = this.props;

    try {
      await this.props.submitGetQuoteForm({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    onComplete();
    const options = {
      message: 'We got your message!',
      description: 'Somebody will be in touch with you within the next 24 hours.',
      duration: 5,
    };
    notification.success(options);
  };

  handleSubmit = e => {
    e.preventDefault();
    const errors = [];
    this.setState({ loading: true, errors });

    this.props.form.validateFields((err, params) => {
      if (err) {
        return this.setState({ loading: false });
      }

      const variables = { params };
      console.log(variables);
      return this.onCreate(variables);
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem label="Name">{getFieldDecorator('firstName', {})(<TextInput />)}</FormItem>
          {/* <FormItem label="Last Name">{getFieldDecorator('lastName', {})(<TextInput />)}</FormItem> */}
          <FormItem label="Organization">{getFieldDecorator('organization', {})(<TextInput />)}</FormItem>
          <FormItem label="Email">{getFieldDecorator('email', {})(<TextInput />)}</FormItem>
          <FormItem label="Phone">{getFieldDecorator('directLine', {})(<TextInput />)}</FormItem>
          <FormItem label="Message">{getFieldDecorator('description', {})(<TextAreaInput />)}</FormItem>
          <ButtonContainer>
            <Button fullWidth onClick={this.handleSubmit} htmlType="submit">
              {this.state.loading && 'SENDING...'}
              {!this.state.loading && 'SEND'}
            </Button>
          </ButtonContainer>
        </Form>
      </div>
    );
  }
}

export default graphql(submitGetQuoteForm, { name: 'submitGetQuoteForm' })(Form.create()(ContactUsForm));



// WEBPACK FOOTER //
// ./src/components/forms/ContactUsForm/index.js